// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.contactum-coupon-options[data-v-bebfec74] {\n  padding: 8px 0;\n}\n.contactum-option-row[data-v-bebfec74] {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 14px;\n}\n.contactum-option-row--switch[data-v-bebfec74] {\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n.contactum-label[data-v-bebfec74] {\n  font-size: 12px;\n  color: #606266;\n  margin-bottom: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
